import { UserInfoModel } from '../Types/UserInfoModel';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Address from '../Types/Address';

type UserInfoStateErrors = { [key: string]: string[] };

interface UserInfoState {
  current?: UserInfoModel;
  errors: UserInfoStateErrors;
  successMessage?: string;
}

const DEFAULT_STATE: UserInfoState = {
  errors: {},
};

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState: DEFAULT_STATE,
  reducers: {
    updateUserInfo: (state, action: PayloadAction<UserInfoModel>) => {
      state.current = action.payload;
    },
    updateUsername: (state, action: PayloadAction<string>) => {
      if (state.current) {
        state.current.username = action.payload;
      }
    },
    updateAddress: (state, action: PayloadAction<Address>) => {
      if (state.current) {
        state.current.address = action.payload;
      }
    },
    updateDeliveryAddress: (state, action: PayloadAction<Address>) => {
      if (state.current) {
        state.current.deliveryAddress = action.payload;
      }
    },
    setErrors: (state, action: PayloadAction<UserInfoStateErrors>) => {
      state.errors = action.payload;
    },
    resetErrors: (state) => {
      state.errors = {};
    },
    setSuccessMessage: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.successMessage = action.payload;
    },
  },
});

export const userInfoActions = userInfoSlice.actions;

export default userInfoSlice.reducer;
